import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/ORGANIZATIONS';
export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    organizationId => ({organizationId}),
    organization => ({organization}),
    error => ({error}),
);
